import React from "react";
import image from "../assets/images/drawers.jpg";

function Image() {
  return (
    <div className="img-container">
      <img src={image} alt="Table" />
    </div>
  );
}

export default Image;
